package de.oevbs.kunde.kundenportal2.authentication

import de.oevbs.kunde.kundenportal2.Pages
import de.oevbs.kunde.kundenportal2.navigation.visit
import de.oevbs.sfa.authentication.AuthenticationParameter
import de.oevbs.sfa.communication.ClientMiddleware
import io.ktor.client.request.*
import io.ktor.client.statement.*
import kotlinx.datetime.Clock

/**
 * [ClientMiddleware], die das Token aus dem [PortalSession]-Objekt verwendet, um die Requests eines Clients
 * anzureichern.
 *
 * Benutzung:
 * ```kotlin
 * val client = SomeClient().use(PortalSessionMiddleware)
 *                               ^^^^^^^^^^^^^^^^^^^^^^^
 *                               Reichert die Request mit dem JWT des Nutzers an
 * ```
 */
// Diese zusätzliche Implementierung wurde einer Umwandlung der PortalSession in eine AuthenticationMiddleware
// vorgezogen, da dies eine nahezu vollständige Neuimplementierung der Authentifizierung zur Folge haben würde und aus
// Zeitgründen aktuell nicht möglich ist.
//
// Diese Lösung wird zweistufig abgelöst durch den Umstieg auf den Oe-Auth-Service und später Azure B2C.
object PortalSessionMiddleware : ClientMiddleware {

    override suspend fun enrichRequest(request: HttpRequestBuilder): HttpRequestBuilder {
        val current =  PortalSession.current

        // Für den Fall, dass der Nutzer entweder nicht angemeldet oder sein Token abgelaufen ist, muss ihm die
        // Login-Seite angezeigt werden. Dies ist ein Workaround und lässt sich durch die Umstellung auf
        // AuthenticationMiddleware eleganter lösen (sieh Kommentar weiter oben).
        if (current == null || current.expiresAt <= Clock.System.now()) {
            PortalSession.portalLogout()
            Pages.root.visit()
            return request.apply {
                executionContext.cancel()
            }
        }

        return request.apply {
            current.token?.let {
                header(AuthenticationParameter.HEADER_TOKEN, "Bearer $it")
            }
        }
    }

    override suspend fun handleResponse(response: HttpResponse): Pair<HttpResponse, Boolean> =
        response to true
}